import React from 'react'
import FavoriteList from "../components/FavoriteList";

const Favorites = () => {
  return (
    <div className="favorite-page">
      <h2>Favorite List</h2>
      <FavoriteList />
    </div>
  );
};

export default Favorites;

